import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = {
        maxSize: Number,
        maxSizeMessage: String,
    };

    connect() {
        const input = this.element;
        const resetButton = this.element.querySelector('.button-reset');

        this.initCustomFileInput(input);

        if (resetButton) {
            resetButton.addEventListener('click', ()=>{
                this.removeError();
                this.resetFileInput(this.element);
            })
        }
    }

    initCustomFileInput(el) {
        const fileInput = el.querySelector('[type="file"]')
        const defaultLabel = el.querySelector('.label-default');
        const resetButton = el.querySelector('.button-reset');
        const label = el.querySelector('.label');

        fileInput.onchange = () => {
                this.removeError();

                if (!fileInput.value) return;

                const value = fileInput.value.replace(/^.*[\\\/]/, '');
                if (!el.classList.contains('chosen')) {
                    el.classList.add('chosen');
                }

                if (!defaultLabel.classList.contains('d-none')) {
                    defaultLabel.classList.add('d-none');
                }

                if (!label.classList.contains('d-block')) {
                    label.classList.add('d-block');
                }

                if (!resetButton.classList.contains('d-block')) {
                    resetButton.classList.add('d-block');
                }
                label.innerText = value;

                // Keep file selected so user sees what is wrong; axios-form blocks submit
                const file = fileInput.files[0];
                if (file && this.maxSizeValue && file.size > this.maxSizeValue) {
                    this.showError(this.maxSizeMessageValue);
                }
            }
    }

    showError(message) {
        if (!message) return;

        const messageNode = document.createElement('span');
        messageNode.classList.add('input-error');
        messageNode.innerText = message;
        this.element.classList.add('invalid');
        this.element.after(messageNode);
    }

    removeError() {
        this.element.classList.remove('invalid');
        const next = this.element.nextElementSibling;
        if (next && next.classList.contains('input-error')) {
            next.remove();
        }
    }

    resetFileInput(el) {
        const fileInput = el.querySelector('[type="file"]');
        const label = el.querySelector('.label');
        const defaultLabel = el.querySelector('.label-default');
        const resetButton = el.querySelector('.button-reset');

        if (fileInput) {
            fileInput.value = null;
        }

        if (resetButton.classList.contains('d-block')) {
            resetButton.classList.remove('d-block');
        }

        if (label && defaultLabel) {
            label.classList.remove('d-block');
            defaultLabel.classList.remove('d-none');
        }
    }
}